module.exports = __webpack_public_path__ + "assets/img/bg.84a2fe3b.png";